const CentraJS = {
    suspend: ()=>{
        if (typeof window === "undefined") return;
        window.CentraCheckout?.suspend();
    },
    resume: (suspendIgnore)=>{
        if (typeof window === "undefined") return;
        window.CentraCheckout?.resume(suspendIgnore);
    },
    reInitiate: (key)=>{
        if (typeof window === "undefined") return;
        window.CentraCheckout?.reInitiate(key);
    }
};

export { CentraJS };
